// @ts-check
// Comandos dos bots (contrato 10 de atendimento, seção 25; contrato de bots, seção 22.4). O atalho G+B (lista dos bots)
// é da fundação (`GO_TO_SHORTCUTS`). "Iniciar o bot <nome>" e "Assumir conversa" aparecem no menu de comandos com a
// conversa aberta (Conversas ou Caixa): a faixa do bot publica a conversa em `activeConversationState` e o registro
// (buildConversationCommands) decide o que oferecer; aqui só a execução, pela mesma API da faixa.
import { startConversationBot, stopConversationBot } from '../../data/bots.js';
import { showErrorSnackbar, showSuccessSnackbar } from '../../ui/snackbar.js';
import { closeSidePanel } from '../side-panel/side-panel-state.js';
import { t } from '../../i18n/index.js';

/** Comandos que o registro oferece na conversa; "Iniciar bot" vem um por bot (`conversation.startBot:<botId>`). */
export const BOT_COMMAND_IDS = /** @type {ReadonlySet<string>} */ (new Set(['conversation.startBot', 'conversation.takeOverBot']));

/** @param {string} id */
const baseIdOf = (id) => id.split(':')[0];

/**
 * Executa um comando dos bots. Devolve false quando o comando não é dos bots.
 * @param {{ id: string, labelParams?: Record<string, unknown> }} command
 * @param {{ conversation?: { threadId: string, runningBotName?: string | null, onChanged?: () => void } | null }} runtime
 * @returns {Promise<boolean>}
 */
export async function runBotCommand(command, runtime) {
  const baseId = baseIdOf(command.id);
  if (!BOT_COMMAND_IDS.has(baseId)) return false;
  const conversation = runtime.conversation;
  if (!conversation?.threadId) return true;
  closeSidePanel();
  try {
    if (baseId === 'conversation.startBot') {
      const botId = typeof command.labelParams?.botId === 'string' ? command.labelParams.botId : command.id.split(':')[1];
      if (!botId) return true;
      await startConversationBot(conversation.threadId, botId);
      showSuccessSnackbar(t('bots.startMenu.started', { name: String(command.labelParams?.name ?? '') }));
    } else {
      await stopConversationBot(conversation.threadId);
      showSuccessSnackbar(t('bots.banner.tookOver'));
    }
    conversation.onChanged?.();
  } catch (error) {
    showErrorSnackbar(error);
  }
  return true;
}
